<div class="news">
  <span class="news__startDate">{{ newsItem().created | dayjs }}</span>
  <span class="news__headline">
    {{ newsItem().headline }}
  </span>
  @if (newsItem().comment) {
    <span class="news__content">{{ newsItem().comment }}</span>
  }

  <div class="news__tag-list">
    @for (carrier of newsItem().carrier; track carrier) {
      <span class="badge badge-light mr--4">{{ carrier }}</span>
    }
    @for (country of newsItem().country; track country) {
      <span class="badge badge-light mr--4">{{ country }}</span>
    }
  </div>
  <div>
    <p-button
      icon="pi pi-external-link"
      [label]="'pages.transport.tracking-overview.widgets.news-updates.read-more' | translate"
      (onClick)="onReadMoreClick()"
      styleClass="ps-0"
      variant="text"
    />
  </div>
</div>
